import { useApolloClient } from '@apollo/client';

import { RECAPTCHA_QUERIES } from './RecaptchaQueries.graphql';

export const useRecaptcha = () => {
  const client = useApolloClient();

  const verifyToken = async (token: string, listingId: string) => {
    try {
      const { data } = await client.query({
        query: RECAPTCHA_QUERIES,
        variables: { token, listingId },
      });
      if (data.recaptchaVerify) return data.recaptchaVerify;
    } catch (error: any) {
      console.log('recaptcha error', error.message);
    }
    return { valid: false };
  };

  return { verifyToken };
};
